// Créditos da desenvolvedora do sistema, exibidos no app (login, rodapé, "Sobre") e nos PDFs.
export const DESENVOLVEDORA = {
  nome: "Master Soluti",
  razaoSocial: "MASTER SOLUTI SOLUCOES EM TECNOLOGIA LTDA",
  cnpj: "59.596.004/0001-27",
  telefone: "(31) 3058-0476",
  /** Para links tel: */
  telefoneE164: "+553130580476",
  slogan: "TECNOLOGIA SOB CONTROLE. NEGÓCIOS EM MOVIMENTO.",
  site: "https://mastersoluti.com.br",
  siteRotulo: "mastersoluti.com.br",
  /** Azul-marinho do logotipo. */
  cor: "#002a47",
} as const;
